import { imagePicker_template } from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import { imagePickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { imageWidget_template } from "./imageWidget_template";
import { filterTag_template } from "./filterTag_template";
import { DragAndDropHandler } from "../../utils/DragAndDropHandler";
import { validationsList_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { Utilities as ClaidiUtilities } from "../../../vendor/valnet/valnet_imagePicker/js/claidai/utilities";
import * as classicEditor from "@ckeditor/ckeditor5-build-classic";

declare var ko: any;
declare var Dropzone: any;
declare var CKEDITOR: any;

export class imagesEdit_template extends vnTemplate {
    protected pagination: pagination_template;
    public filterTag: filterTag_template;
    public validationsList: validationsList_template;
    public imageDescriptionEditor;
    public imageCaptionEditor;

    protected getTemplateHtml(): string {
        return /* html */ `
            <div class="form-header image-edit">
                <!-- ko ifnot: $data.id() -->
                    <h3 class="form-title icon i-image-2">Bulk Create Images</h3>
                <!-- /ko -->
                <!-- ko if: $data.id() -->
                    <h3 class="form-title icon i-image-2">Edit Image</h3>
                <!-- /ko -->
                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
            </div>

            <div data-bind="css: { 'is-visible': isOptimizationWidthClaidOpen }" class="w-lightbox light-theme">
                <div class="img-picker-content" id="add-image-upload-zone">
                    <div class="w-form lightbox-form" id="optimizer-popup">
                        <div class="form-header">
                            <h3 class="form-title">Optimize Images</h3>
                        </div>
                        <div class="form-body optimizer-body">
                            <div class="form-group">
                                <div class="opt-group">
                                    <p class="form-text">Would you like to apply AI image upscaling to the upload?</p>
                                    <div class="icon i-emaki-lab opt-icon"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: noOptimization }" class="btn">No</button>
                            <button type="button" data-bind="event: { click: uploadOptimizedImages }" class="btn opt-btn btn-form icon i-emaki-lab e-lab">Yes</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ww-form-body" data-bind="css: { 'is-showing': true }">

                <div class="w-form-body image">
                    <div class="form-body">

                        <strong class="form-sub-title">Upload</strong>

                        <div class="form-group inside-label">
                            <label for="url" class="form-label">Image(s)</label>
                            <!-- ko if: $data.id() -->
                                <div class="w-img">
                                <!-- ko if: url !== null -->
                                    <img data-bind="attr: {src: url  }" style="max-height: 10rem;">
                                <!-- /ko -->
                                </div>
                                <input id="url" data-bind="value: url" type="hidden">
                            <!-- /ko -->
                            <!-- ko ifnot: $data.id() -->
                                <div id="dropzone">
                                    <div id="image-dropzone" class="dropzone"></div>
                                </div>
                            <!-- /ko -->
                        </div>

                        <div class="form-group">
                            <dl class="double-list">
                                <!-- ko if: images().length > 1 -->
                                    <!-- ko foreach: { data: images(), as: 'image' } -->
                                    <dt></dt><dd></dd>
                                    <dt><span>Name</span></dt>
                                    <dd><span data-bind="text: image.name"></span></dd>
                                    <dt><span>Alternate Image Text</span></dt>
                                    <dd><span data-bind="text: image.altText"></span></dd>
                                    <dt style="grid-column: 1 / span 2">
                                        <span>URL</span>
                                    </dt>
                                    <dd class="flex"
                                        style="
                                            grid-column: 1 / span 2;
                                            text-align: left;
                                            line-break: anywhere;
                                            border-bottom: 0px solid black;
                                        "
                                    >
                                        <span class="no-cap" data-bind="text: image.url"></span>
                                        <a style="margin-left: 1rem;"
                                            class="btn icon border only-icon i-full-size"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            data-bind="attr: { href: image.url }"
                                        ></a>
                                    </dd>
                                    <dt><span>Size</span></dt>
                                    <dd><span data-bind="visible: !!image.fileSize, text: image.sizeHuman"></span></dd>
                                    <dt>
                                        <span>Dimension</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: image.width"></span>
                                        <span class="no-cap">px&nbsp;x&nbsp;</span>
                                        <span data-bind="text: image.height"></span>
                                        <span class="no-cap">px</span>
                                    </dd>
                                    <dt><span>Ratio</span></dt><dd><span data-bind="text: image.ratio"></span></dd>
                                    <dt><span>Is AI Enhanced</span></dt><dd><span class="no-cap" data-bind="text: image.isAiEnhanced? 'Yes' : 'No' "></span></dd>
                                    <dt><span>MIME Type</span></dt><dd><span class="no-cap" data-bind="text: image.mimeType"></span></dd>
                                    <dt><span>Date Uploaded</span></dt><dd><span>--</span></dd>
                                    <dt><span>Date Updated</span></dt><dd><span>--</span></dd>
                                    <dt></dt><dd></dd>
                                    <!-- /ko -->
                                <!-- /ko -->
                                <!-- ko if: images().length <= 1 -->
                                <dt style="grid-column: 1 / span 2">
                                    <span>URL</span>
                                </dt>
                                <dd class="flex"
                                    style="
                                        grid-column: 1 / span 2;
                                        text-align: left;
                                        line-break: anywhere;
                                        border-bottom: 0px solid black;
                                    "
                                >
                                    <span class="no-cap" data-bind="text: url"></span>
                                    <a style="margin-left: 1rem;"
                                        class="btn icon border only-icon i-full-size"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-bind="attr: { href: url }"
                                    ></a>
                                </dd>
                                <dt><span>Size</span></dt>
                                <dd><span data-bind="visible: !!fileSize(), text: sizeHuman()"></span></dd>
                                <dt>
                                    <span>Dimension</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: width()"></span>
                                    <span class="no-cap">px&nbsp;x&nbsp;</span>
                                    <span data-bind="text: height()"></span>
                                    <span class="no-cap">px</span>
                                </dd>
                                <dt><span>Ratio</span></dt><dd><span data-bind="text: ratio()"></span></dd>
                                <dt><span>Is AI Enhanced</span></dt><dd><span class="no-cap" data-bind="text: isAiEnhanced()? 'Yes' : 'No' "></span></dd>
                                <dt><span>MIME Type</span></dt><dd><span class="no-cap" data-bind="text: mimeType()"></span></dd>
                                <dt><span>Date Uploaded</span></dt><dd><span data-bind="text: dateCreated"></span></dd>
                                <dt><span>Date Updated</span></dt><dd><span data-bind="text: dateUpdated"></span></dd>
                                <!-- /ko -->
                            </dl>
                        </div>
                    </div>

                    <div class="form-body videos_edit"> <!-- for the styles -->

                        <strong class="form-sub-title">Image Information</strong>

                        <!-- ko if: images().length <= 1 -->
                        <div class="form-group inside-label">
                            <label for="name" class="form-label">Name</label>
                            <input id="name" data-bind="value: name" type="text" class="input-text" required>
                        </div>
                        <!-- /ko -->
                        <div class="form-group" style="align-items: flex-start;">
                            <label class="form-label" for="">Credit Text</label>
                            <input class="input-text" type="text" id="image_caption" data-bind="value: caption">
                        </div>
                        <div class="form-group inside-label">
                            <label for="description" class="form-label">Description</label>
                            <textarea  id="image_description" name="image_description" data-bind="value: description"></textarea>
                        </div>
                        <!-- ko if: images().length <= 1 -->
                        <div class="form-group inside-label">
                            <label for="alt-text" class="form-label">Alternate Image Text</label>
                            <input id="alt-text" class="input-text" type="text" data-bind="value: altText" required>
                        </div>
                        <!-- /ko -->
                        <div class="form-group">
                            <div class="form-check-inline" data-bind="if: hasAccessIsUnderEmbargo() && permissions()['article_edit_embargo'].write">
                                <input type="checkbox" data-bind="checked: isUnderEmbargo" id="isUnderEmbargo">
                                <label for="isUnderEmbargo" class="form-label icon i-check">Under Embargo</label>
                            </div>
                            <div class="form-group form-check-inline" data-bind="css: {'is-disable' : id() }">
                                <input type="checkbox" data-bind=" checked: isWaterMark" id="imagePicker-watermark">
                                <label for="imagePicker-watermark" class="form-label icon i-check">WaterMark</label>
                            </div>
                        </div>
                        <div class="form-group inside-label" style="align-items: flex-start;">
                            <label class="form-label" style="width: auto;">Tags</label>
                            ${this.filterTag.getHtmlBuild()}
                        </div>
                        ${ this.validationsList.getHtmlBuild() }
                        <div class="form-group" data-bind="foreach: selectedTags, childrenComplete : handleDragAndDrop($element, selectedTags ,'.tag-element')">
                            <div class="btn-selection tag-element">
                                <div class="drag-handle i-move short"><button type="button" class="btn no-bg icon i-drag"></button></div>
                                <input type="radio" name="tag" data-bind="attr: { value: $data.tag.id, id: 'tag_' + $data.tag.id, checked: $parent.idPrimaryTag() == $data.tag.id ? $parent.idPrimaryTag() : null }, event: { click: $parent.onClickSetSelectedPrimaryTag }">
                                <label class="form-label" data-bind="text: $data.tag.name + ' ' + $data.tag.formattedTagTypeAndDataset, attr: { for: 'tag_' + $data.tag.id }"></label>
                                <button class="icon i-x-after" type="button" data-bind="visible: true, event: { click: $parent.onClickDeleteSelectedTag }"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-footer">
                <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                <button data-bind="
                        event: { click: onClickSave },
                        text: id()? 'Save Image' : 'Save Images'
                    "
                    class="btn highlight"
                    type="button"
                ></button>
            </div>
        `;
    }

    protected initPartial(): void {
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);

        this.filterTag = new filterTag_template("filterTag", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {
        return "imagesEdit-form-template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large"];
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            id: ko.observable(null),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),
            description: ko.observable(""),
            details: ko.observable(""),
            height: ko.observable(""),
            length: ko.observable(""),
            mimeType: ko.observable(""),
            ratio: ko.observable(""),
            fileSize: ko.observable(""),
            sizeHuman: ko.observable(""),
            isWaterMark: ko.observable(false),
            name: ko.observable(""),
            altText: ko.observable(""),
            url: ko.observable(""),
            width: ko.observable(""),
            isEditShown: ko.observable(false),
            isUnderEmbargo: ko.observable(false),
            hasAccessIsUnderEmbargo: ko.observable(false),
            lockItem: ko.observable(true),
            permissions: ko.observableArray(this.initPermissions(["article_edit_embargo"])),
            showImageUrlButton: ko.observable(false),
            selectedTags: ko.observableArray([]),
            isOptimizationWidthClaidOpen: ko.observable(false),
            optimizeWithClaid: ko.observable(false),
            idPrimaryTag: ko.observable(null),
            uploadError: ko.observable(),
            newFile: ko.observable(),
            newFiles: ko.observable([]),
            images: ko.observable([]),
            caption: ko.observable(''),
            imageDropzone: ko.observable(),
            isAiEnhanced: ko.observable(false),
            stagingfiles: ko.observable(true),
            setOptionDisable: function (option, item) {
                ko.applyBindingsToNode(option, { disable: item.disable }, item);
            },
            onClickSave: (data) => {
                self.onClickSave();
            },
            onClickCancel: (data, event) => {
                self.onClickCancel();
            },
            handleDragAndDrop: function (element, currentObservableArray, childrenSelector) {
                self.handleDragAndDrop(element, currentObservableArray, childrenSelector);
            },
            onClickDeleteSelectedTag: function (data, event) {
                self.onClickDeleteSelectedTag(data);
            },
            onClickSetSelectedPrimaryTag: function (data, event) {
                self.setSelectedPrimaryTag(data);
                return true;
            },
            onClickOpenUploadImagePopup: function (data, event) {
                self.openUploadImagePopup();
            },
            onClickCloseUploadImagePopup: function (data, event) {
                self.closeUploadImagePopup();
            },
            noOptimization: async function(data, event){ self.noOptimization();},
            uploadOptimizedImages: async function(data, event){ self.uploadOptimizedImages();},
        };
    }

    protected onClickCancel(): void {
        this.caller.goBack();
    }

    protected onClickSave(): void {
        this.caller.save();
    }

    public setId(id): void {
        this.getTemplateViewModel().id(id);
    }

    public setName(name): void {
        this.getTemplateViewModel().name(name);
    }

    public setDescription(description): void {
        this.getTemplateViewModel().description(description);
    }

    public setCaption(caption): void {
        this.getTemplateViewModel().caption(caption);
    }

    public setAltText(altText): void {
        this.getTemplateViewModel().altText(altText);
    }

    public setUrl(url): void {
        this.getTemplateViewModel().url(url);
    }

    public setLength(length): void {
        this.getTemplateViewModel().length(length);
    }

    public setFileSize(size): void {
        this.getTemplateViewModel().fileSize(size);
    }

    public setSizeHuman(size): void {
        this.getTemplateViewModel().sizeHuman(this.formatBytes(size));
    }

    public setHeight(height): void {
        this.getTemplateViewModel().height(height);
    }

    public setWidth(width): void {
        this.getTemplateViewModel().width(width);
    }

    public setRatio(ratio): void {
        this.getTemplateViewModel().ratio(ratio);
    }

    public setMimeType(mimeType): void {
        this.getTemplateViewModel().mimeType(mimeType);
    }

    public setDateCreated(dateCreated): void {
        this.getTemplateViewModel().dateCreated(dateCreated);
    }

    public setDateUpdated(dateUpdated): void {
        this.getTemplateViewModel().dateUpdated(dateUpdated);
    }

    public setIdPrimaryTag(idPrimaryTag): void {
        this.getTemplateViewModel().idPrimaryTag(idPrimaryTag);
    }

    public setDetails(details): void {
        this.getTemplateViewModel().details(details);
    }

    public setIsWatermark(isWatermark): void {
        this.getTemplateViewModel().isWatermark(isWatermark);
    }

    public setIsUnderEmbargo(isUnderEmbargo): void {
        this.getTemplateViewModel().isUnderEmbargo(isUnderEmbargo);
    }

    public setHasAccessIsUnderEmbargo(hasAccessIsUnderEmbargo) {
        this.getTemplateViewModel().hasAccessIsUnderEmbargo(hasAccessIsUnderEmbargo);
    }

    public setLockItem(lockItem) {
        this.getTemplateViewModel().lockItem(lockItem);
    }

    public setPermissions(permissions) {
        this.getTemplateViewModel().hasAccessIsUnderEmbargo(permissions.article_list_brand.read);

        this.getTemplateViewModel().permissions(permissions);
    }

    public generateDropzone(image) {
        if (!document.getElementById('image-dropzone')) {
            return;
        }

        let clickable = image.id ? false : true;
        let imageDropzone = new Dropzone("div#image-dropzone", {
            url: this.caller.getUploadUrl(),
            maxFiles: 25,
            autoQueue: false,
            addRemoveLinks: true,
            acceptedFiles: "image/jpg,image/jpeg,image/png,image/gif",
            clickable: clickable,
            maxFilesize: 1024 * 1024 * 40000, // 41,943,040,000
        });
        let _this = this;

        imageDropzone.on("success", function (file, fileInfo) {

            if (fileInfo.images && fileInfo.images.length) {
                fileInfo = fileInfo.images[0];
            }

            if (fileInfo.sizeWarning === true) {
                if (confirm(fileInfo.sizeWarningMessage) === false) {
                    this.removeFile(file);
                }
            }

            _this.updateFileInfoAfterUpload(fileInfo, file);
        });
        imageDropzone.on("error", function (file, message) {
            const elements = document.querySelectorAll(".dz-error-message span");
            const lastElement = elements[elements.length - 1];
            lastElement.textContent = message;
        });
        imageDropzone.on("removedfile", function (file) {
            console.log('removedfile', file);
            _this.removeFile(file);
        });
        imageDropzone.on("reset", () => _this.resetFileInfo());
        imageDropzone.on("addedfiles", function (files) {
            // stage the file, then figure out if they want to optimize it before uploading.
            if (_this.getTemplateViewModel().stagingfiles()) {
                _this.getTemplateViewModel().newFiles(files);
                _this.showOptimizationWithClaidChoice();
            } else {
                setTimeout(() => {
                    this.enqueueFiles(files)
                    setTimeout(() => this.processQueue(), 0);
                }, 0);
            }

        });
        imageDropzone.on("addedfile", function (file) {
            // stage the file, then figure out if they want to optimize it before uploading.
            if (_this.getTemplateViewModel().stagingfiles()) {
                _this.getTemplateViewModel().newFile(file);
                _this.showOptimizationWithClaidChoice();
            } else {
                setTimeout(() => {
                    this.enqueueFile(file)
                    setTimeout(() => this.processQueue(), 0);
                }, 0);
            }
        });

        this.getTemplateViewModel().imageDropzone(imageDropzone);

        if (image && image.url) {
            let mockFile = { name: image.url, size: parseInt(image.size) };
            imageDropzone.emit("addedfile", mockFile);
            imageDropzone.createThumbnailFromUrl(mockFile, mockFile.name);
            imageDropzone.emit("complete", mockFile);
            imageDropzone.files.push(mockFile);
            _this.getTemplateViewModel().url(image.url);
            _this.getTemplateViewModel().showImageUrlButton(true);
        }
    }

    public showOptimizationWithClaidChoice(){
        this.getTemplateViewModel().isOptimizationWidthClaidOpen(true);
    }

    public hideOptimizationWithClaidChoice(){
        this.getTemplateViewModel().isOptimizationWidthClaidOpen(false);
    }

    public setOptimizeWithClaid(optimizeWithClaid){
        this.getTemplateViewModel().optimizeWithClaid(optimizeWithClaid);
    }

    public removeFile(file) {
        const images = this.getTemplateViewModel().images();

        console.debug(images);
        console.debug(file);
        console.debug('post-filter', images.filter((image) => image.fileReference.name !== file.name));

        this.getTemplateViewModel().images(images.filter((image) => image.fileReference.name !== file.name));
    }

    public async noOptimization(){
        this.setOptimizeWithClaid(false);
        this.hideOptimizationWithClaidChoice();
        this.getTemplateViewModel().isAiEnhanced(false);
        this.getTemplateViewModel().imageDropzone().enqueueFiles(this.getTemplateViewModel().newFiles());
        setTimeout(() => this.getTemplateViewModel().imageDropzone().processQueue(), 0);
    }

    public async uploadOptimizedImages() {
        let files = this.getTemplateViewModel().newFiles();

        try {
            this.getTemplateViewModel().imageDropzone().removeAllFiles();
            files = await this.upscaleFiles(files);
            sessionStorage.removeItem("claidApiErrorMessage");
            this.hideOptimizationWithClaidChoice();
            this.validationsList.clearMessages();
            this.getTemplateViewModel().uploadError(false);
        } catch (error) {

            this.disableLoading("is-generating");
            sessionStorage.setItem("claidApiErrorMessage", error.CustomMessage);
        }

        this.getTemplateViewModel().isAiEnhanced(true);
        // don't stage this one, we've already confirmed they want to optimize.
        this.getTemplateViewModel().stagingfiles(false);
        files.map((file) => this.getTemplateViewModel().imageDropzone().addFile(file));
        // next file will be staged
        setTimeout(() => this.getTemplateViewModel().stagingfiles(true), 0);
    }

    public setIsAiEnhanced(isAiEnhanced)
    {
        this.getTemplateViewModel().isAiEnhanced(isAiEnhanced);
    }

    public enableLoading(cssClass = "loading") {
        let currentComponent = document.getElementById('edit');
        let currentElement = currentComponent.querySelector('.lightbox-form');
        currentElement.classList.add(cssClass);
    }

    public disableLoading(cssClass = "loading"){
        let currentComponent = document.getElementById('edit');
        let currentElement = currentComponent.querySelector('.lightbox-form');
        currentElement.classList.remove(cssClass);
    }

    public async upscaleFiles(files: File[]): Promise<File[]> {

        this.enableLoading("is-generating");
        const operations = {
            operations: {
                restorations: {
                    decompress: "auto",
                    upscale: "smart_enhance"
                }
            }
        };

        const optimizedFiles: File[] = await ClaidiUtilities.createUpscaledFiles(files, operations);

        this.disableLoading("is-generating");
        return optimizedFiles;
    }

    public updateFileInfoAfterUpload(fileInfo, fileReference)
    {
        const image = {
            name: fileInfo.name,
            altText: fileInfo.altText,
            height: fileInfo.height,
            width: fileInfo.width,
            url: fileInfo.url,
            mimeType: fileInfo.mimeType,
            ratio: fileInfo.ratio,
            fileSize: fileInfo.fileSize,
            isAiEnhanced: this.getTemplateViewModel().isAiEnhanced(),
            sizeHuman: this.formatBytes(fileInfo.fileSize * 1024),
            fileReference: fileReference,
        };
        this.getTemplateViewModel().images([...this.getTemplateViewModel().images(), image]);

        this.getTemplateViewModel().name(fileInfo.name);
        this.getTemplateViewModel().altText(fileInfo.altText);
        this.getTemplateViewModel().height(fileInfo.height);
        this.getTemplateViewModel().width(fileInfo.width);
        this.getTemplateViewModel().url(fileInfo.url);
        this.getTemplateViewModel().mimeType(fileInfo.mimeType);
        this.getTemplateViewModel().ratio(fileInfo.ratio);
        this.getTemplateViewModel().fileSize(fileInfo.fileSize * 1024);
        this.getTemplateViewModel().sizeHuman(this.formatBytes(fileInfo.fileSize * 1024));
        this.getTemplateViewModel().showImageUrlButton(true);
    }

    public resetFileInfo()
    {
        this.getTemplateViewModel().name('');
        this.getTemplateViewModel().altText('');
        this.getTemplateViewModel().height('');
        this.getTemplateViewModel().width('');
        this.getTemplateViewModel().url('');
        this.getTemplateViewModel().mimeType('');
        this.getTemplateViewModel().ratio('');
        this.getTemplateViewModel().fileSize('');
        this.getTemplateViewModel().sizeHuman('');
        this.getTemplateViewModel().showImageUrlButton(false);
    }

    public formatBytes(bytes, decimals = 2, binaryUnits = 1024) {
        if (bytes == 0) {
            return "0 Bytes";
        }
        var unitMultiple = binaryUnits ? 1024 : 1000;
        var unitNames =
            unitMultiple === 1024 // 1000 bytes in 1 Kilobyte (KB) or 1024 bytes for the binary version (KiB)
                ? ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
                : ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        var unitChanges = Math.floor(Math.log(bytes) / Math.log(unitMultiple));
        return (
            parseFloat((bytes / Math.pow(unitMultiple, unitChanges)).toFixed(decimals || 0)) +
            " " +
            unitNames[unitChanges]
        );
    }

    public getTagsSuggestion(keyword, idSourceElement) {
        this.caller.getTagsSuggestion(keyword);
    }

    // region tag filter
    public updateSelectedTags() {
        let idTagSelected = this.filterTag.getTemplateViewModel().idTag();
        let tagSelected = this.filterTag.getTemplateViewModel().tagObj();
        let selectedTags = this.getTemplateViewModel().selectedTags();

        if (idTagSelected != null) {
            //add to selected tags if its not already selected
            let alreadySelected = selectedTags.find((t) => t.tag.id == idTagSelected);

            if (!alreadySelected) {
                if (tagSelected.tagType != null) {
                    tagSelected.type = {};
                    tagSelected.type.id = tagSelected.idType;
                    tagSelected.type.name = tagSelected.tagType;
                }
                selectedTags.push({ id: null, tag: tagSelected });
            }
        }

        this.getTemplateViewModel().selectedTags([]);
        this.getTemplateViewModel().selectedTags(selectedTags);
        this.filterTag.clearInput();
    }

    protected setTagFilterAutocomplete(tags) {
        this.filterTag.getTemplateViewModel().tags(tags);
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {
        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);
    }

    public setSelectedTags(selectedTags): void {
        selectedTags.forEach((t) => {
            let formattedTagTypeAndDataset = "";
            if (t.tag.type != null) {
                formattedTagTypeAndDataset = " (" + t.tag.type.name + ")";
            }

            if (!t.tag["formattedTagTypeAndDataset"]) {
                t.tag["formattedTagTypeAndDataset"] = formattedTagTypeAndDataset;
            }
        });
        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    protected onClickDeleteSelectedTag(data) {
        let idPrimaryTag = this.getTemplateViewModel().idPrimaryTag();
        let selectedTags = this.getTemplateViewModel().selectedTags();
        let index = selectedTags.findIndex((i) => i.tag.id == data.tag.id);
        if (index != -1) {
            selectedTags.splice(index, 1);
        }

        if (idPrimaryTag == data.tag.id) {
            this.getTemplateViewModel().idPrimaryTag(null);
        }

        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    protected setSelectedPrimaryTag(data) {
        this.getTemplateViewModel().idPrimaryTag(data.tag.id);
    }
    // endregion tag filter

    public openUploadImagePopup() {
        document.getElementById('upload-image-popup').classList.add('is-visible');
        document.body.classList.add('is-fixed');
    }

    public closeUploadImagePopup() {
        document.getElementById('upload-image-popup').classList.remove('is-visible');
        document.body.classList.remove('is-fixed');
    }

    public setImageDescription(description) {

        if(!this.imageDescriptionEditor){
            this.initializeCkEditors();
        }

        this.imageDescriptionEditor.setData(description, function () {
            this.resetUndo();
        });
    }

    public setImageCaption(caption) {

        if(!this.imageCaptionEditor){
            this.initializeCkEditors();
        }

        this.imageCaptionEditor.setData(caption, function () {
            this.resetUndo();
        });
    }

    public getImageDescription() {

        return this.imageDescriptionEditor.getData();
    }


    public getImageCaption() {
        return this.imageCaptionEditor.getData();
    }
    protected initializeCkEditors() {

        for(let name in CKEDITOR.instances)
        {
            if (name == "image_description" || name == "image_caption") {
                CKEDITOR.instances[name].destroy(true);
            }
        }

        if (!CKEDITOR.stylesSet.registered.my_styles) {
            CKEDITOR.stylesSet.add('my_styles', [
                // Block-level styles.
                {name: 'Heading 1', element: 'h1'},
                {name: 'Heading 2', element: 'h2'},
                {name: 'Heading 3', element: 'h3'},
                {name: 'Preformatted', element: 'pre'},
                // Inline styles.
                {name: 'Related: One link', element: 'span', attributes: {'class': 'related-single'}},
                {name: 'Next - One link', element: 'span', attributes: {'class': 'next-single'}},
                {name: 'Affiliate - One link', element: 'span', attributes: {'class': 'affiliate-single'}},
                {name: 'Spoiler Alert', element: 'span', attributes: {'class': 'article-alert'}},
                {name: 'Tip', element: 'div', attributes: {'class': 'emaki-custom tip'}},
                {name: 'Warning', element: 'div', attributes: {'class': 'emaki-custom warning'}},
                {name: 'Note', element: 'div', attributes: {'class': 'emaki-custom note'}},
                {name: 'Expandable', element: 'div', attributes: {'class': 'emaki-custom expandable'}},
                {name: 'Pullquote', element: 'div', attributes: {'class': 'emaki-custom pullquote'}},
                {name: 'Promoted', element: 'div', attributes: {'class': 'emaki-custom promoted'}},

            ]);
        }
        //                {name: '', element: 'span', attributes: {'data-field': 'rating'}},


        CKEDITOR.on('dialogDefinition', function (ev) {
            var dialogName = ev.data.name;
            var dialogDefinition = ev.data.definition;

            //Remove background color and border color in dialog cells properties
            if(dialogName == "cellProperties"){
                // "bgColor"
                // "borderColor"
                const cellProps = dialogDefinition.getContents('info');
                cellProps.remove("borderColor")
                cellProps.remove("bgColor")
            }

            //remove features from table dialog
            if (dialogName == 'table') {

                // Get the advanced tab reference
                var infoTab2 = dialogDefinition.getContents('advanced');

                //Set the default
                // Remove the 'Advanced' tab completely
                dialogDefinition.removeContents('advanced');

                // Get the properties tab reference
                var infoTab = dialogDefinition.getContents('info');

                // Remove unnecessary bits from this tab
                /// infoTab.remove('txtBorder');
                infoTab.remove('cmbAlign');
                infoTab.remove('txtWidth');
                infoTab.remove('txtHeight');
                // infoTab.remove('txtCellSpace');
                //infoTab.remove('txtCellPad');
                infoTab.remove('txtCaption');
                infoTab.remove('txtSummary');
            }


            if (dialogName == 'link') {

                /* Getting the contents of the Target tab */

                var targetTab = dialogDefinition.getContents('target');
                var informationTab = dialogDefinition.getContents('info');
                var advancedTab = dialogDefinition.getContents('advanced');

                //remove the browse server button
                informationTab.remove('browse')

                //moving the target dropdown to the main tab
                var targetField = targetTab.get('linkTargetType');

                targetTab.remove('linkTargetType');
                informationTab.add(targetField);

            }
        });

        let allEditors = [];

        //Directory item CK editor


        // Image Description Editor
        this.initCkEditor('image_description');
        this.imageDescriptionEditor = CKEDITOR.instances.image_description;
        allEditors.push(this.imageDescriptionEditor);

        // Image Caption Editor
        this.initCkEditor('image_caption');
        this.imageCaptionEditor = CKEDITOR.instances.image_caption;
        allEditors.push(this.imageCaptionEditor);


    }

    protected initCkEditor(idElement) {

        let height, toolbarMA;
        let disallowedContent = 'p';
        //contextmenu,tabletools,tableselection
        let removePlugins = 'elementspath,liststyle,image,forms';
        if ( idElement == "image_description" || idElement == "image_caption" || idElement == "gallery_description")
        {
            disallowedContent += ',ul,ol,li';
            removePlugins+= ',list';
            toolbarMA = [[ 'Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-',  'SpecialChar', 'Bold', 'Italic', 'Strike', '-','LinkBtn', 'Maximize']];
            height = '125px';
        }
        else
        {
            height = '500px';
            //height = '1500px';
            toolbarMA = [['Source', '-', 'Cut', 'Copy', 'Paste', '-', 'Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-', 'Table', 'HorizontalRule', 'SpecialChar', 'ImgBtn', 'VideoBtn', 'TagBtn', 'EmbedBtn', 'UpdateBtn','KeyPointsBtn','Styles'], ['Bold', 'Italic', 'Strike', 'NumberedList', 'BulletedList', '-', 'Blockquote', 'LinkBtn', 'Maximize']];
        }

        CKEDITOR.replace(idElement, {
            height: height,
            toolbar: 'MA',
            fillEmptyBlocks: false,
            extraAllowedContent: 'span(*)[!data-field];img(*){*}[*];div(*){*}[*];pre(*){*}[*];code(*){*}[*];a[rel];a[target];a[href];a[title];a(*);*[id];blockquote(*){*}[*];iframe(*){*}[*];p(*){*}[*];script(*){*}[*];section(*){*}[*];button(*){*}[*];ul(*){*}[*];li(*){*}[*];h2(*){*}[*];h3(*){*}[*];dl(*){*}[*];dt(*){*}[*];dd(*){*}[*];video(*){*}[*];audio(*){*}[*];source(*){*}[*]',
            disallowedContent: disallowedContent,
            removePlugins: removePlugins,
            stylesSet: 'my_styles',
            format_tags: "p;h1;h2;h3",
            format_p: {
                element: 'p'
            },
            toolbar_MA : toolbarMA
        });

        //'JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock'
        //'Outdent','Indent'



        //CKEDITOR.config.toolbar_MA = toolbarMA;

        CKEDITOR.config.enterMode = CKEDITOR.ENTER_BR;

        CKEDITOR.config.contentsCss = [CKEDITOR.getUrl('contents.css'), '/css/cke_style.css?v=7.5'];

        //CKEDITOR.config.disallowedContent = 'p';

        CKEDITOR.config.skin = "n1theme";
        //CKEDITOR.config.skin ="kama";
        //CKEDITOR.config.skin ="moono";
        //CKEDITOR.config.skin ="moono-lisa";
        CKEDITOR.config.extraPlugins = "wordcount,notification,openlink";
        //CKEDITOR.config.extraPlugins ="justify";
        //CKEDITOR.config.extraPlugins ="colorbutton";

        CKEDITOR.config.forcePasteAsPlainText = false;
        //contentEditor = CKEDITOR.instances.article_content;

        CKEDITOR.config.wordcount = {
            // Whether or not you want to show the Paragraphs Count
            showParagraphs: false,

            // Whether or not you want to show the Word Count
            showWordCount: true,

            // Whether or not you want to show the Char Count
            showCharCount: true
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/imagesEdit_template.ts